import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

interface UserState {
  id: string | null;
  name: string;
  email: string | null;
  email_verified_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  access_token: string | null;
  status: {
    updating: boolean;
  };
  lastFetchedBookings: string | false;
}

const initialState: UserState = {
  id: null,
  name: '',
  email: null,
  email_verified_at: null,
  created_at: null,
  updated_at: null,
  access_token: null,
  status: {
    updating: false,
  },
  lastFetchedBookings: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateToken: (state, action: PayloadAction<string>) => {
      state.access_token = action.payload;
    },

    updateUser: (state, action: PayloadAction<Partial<UserState>>) => {
      Object.assign(state, action.payload);
    },

    resetUser: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    // Handle data from GET_BOOKINGS_COMMIT
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      user?: Partial<UserState>;
      bookings?: any[];
      [key: string]: any;
    }>) => {
      const { user } = action.payload;
      
      if (user) {
        Object.assign(state, user);
      }
      state.lastFetchedBookings = moment().format('YYYY-MM-DD HH:mm:ss');
    });
  },
});

export const {
  updateToken,
  updateUser,
  resetUser,
} = userSlice.actions;

export default userSlice.reducer;